import * as actionType from "../constants";

const updateRowStatus = (inputs, newstatus, any) => async (dispatch) => {
  try {
    if (any == "status") {
      return;
    }
    dispatch({
      type: actionType.UPDATE_ROW_STATUS,
      payload: { id: inputs, newStatus: newstatus },
    });
    return;
  } catch (error) {
    console.log(error);
  }
};

export default updateRowStatus;
